// extracted by mini-css-extract-plugin
export default {"wrapperPadding":"NavigationPreference_wrapperPadding__HiBCZ"};